import { createSelector } from 'reselect';
import {
  isGCSMember,
  getMemberCardShortNames
} from 'src/universal/redux/cardMemberInfo.js';
import { getPageGlobalData } from 'src/universal/redux/page';

export const isCmCard = createSelector(
  [isGCSMember, getMemberCardShortNames, (_, shortName) => shortName],
  (isCm, cmCards, shortName) => {
    return isCm && cmCards.includes(shortName);
  }
);

export const getCmCardBadgeText = createSelector(
  getPageGlobalData,
  globalData => globalData?.globalHeaderPage?.cmBadgeText
);
